import {
    Directive,
    Input,
    TemplateRef,
    ComponentRef,
    ElementRef,
    Renderer2,
    Injector,
    ComponentFactoryResolver,
    ViewContainerRef,
    HostListener,
    Type,
    OnDestroy,
} from '@angular/core';
import { TooltipComponent } from './tooltip.component';
// tslint:disable-next-line:directive-selector
@Directive({
    selector: '[tooltip]',
})
export class TooltipDirective implements OnDestroy {
    @Input('tooltip') content: string | TemplateRef<any> | Type<any>;

    @Input() tooltipPosition: 'above' | 'below' = 'below';
    @Input() zIndex: number;

    private componentRef: ComponentRef<TooltipComponent>;

    private resizeTimeout: any;

    constructor(
        private element: ElementRef,
        private renderer: Renderer2,
        private injector: Injector,
        private resolver: ComponentFactoryResolver,
        private vcr: ViewContainerRef
    ) {}

    @HostListener('window:resize')
    onWindowResize() {
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        this.resizeTimeout = setTimeout(
            (() => {
                this.onClick(false);
                this.onClick(false);
            }).bind(this),
            100
        );
    }
    @HostListener('click', ['$event'])
    onClick(destroy?: boolean) {
        // If the tooltip is already open it, close it.
        if (this.componentRef || destroy === true) {
            this.destroy();
            return;
        }

        // Otherwise, open the tooltip:
        const factory = this.resolver.resolveComponentFactory(TooltipComponent);
        const injector = Injector.create({
            providers: [
                {
                    provide: 'tooltipConfig',
                    useValue: {
                        host: this.element.nativeElement,
                        tooltipPosition: this.tooltipPosition,
                        zIndex: this.zIndex,
                    },
                },
            ],
        });

        this.componentRef = this.vcr.createComponent(factory, 0, injector, this.generateNgContent());
    }

    generateNgContent() {
        // Text:
        if (typeof this.content === 'string') {
            // const element = this.renderer.createElement(this.content)
            const element = this.renderer.createElement('div');
            (element as HTMLElement).innerHTML = this.content;
            return [[element]];
        }

        // Template:
        if (this.content instanceof TemplateRef) {
            const embeddedViewRef = this.content.createEmbeddedView({});
            return [embeddedViewRef.rootNodes];
        }

        // Component:
        const factory = this.resolver.resolveComponentFactory(this.content);
        const viewRef = factory.create(this.injector);
        return [[viewRef.location.nativeElement]];
    }

    destroy() {
        if (this.componentRef) {
            this.componentRef.destroy();
        }

        this.componentRef = null;
    }

    ngOnDestroy() {
        this.destroy();
    }
}
